/**
 * The leave-laws feed published at vacationtracker.io/leave-types-api/leave-types-api.json:
 * statutory leave entitlements per jurisdiction, keyed by a slug ('wyoming', 'new_mexico').
 */

/** One statutory leave entitlement. `key` is the stable identifier - never match on `name`. */
export interface ILeaveLawSuggestion {
  id: number
  key: string
  name: string
  sortOrder: number
  daysPerYear: number
  hasUnlimitedDays: boolean
  /** Always null in the live feed. Read shortestLeaveIntervalEnum instead. */
  shortestLeaveInterval: string | null
  isApprovalRequired: boolean
  /** Contradicts shortestLeaveIntervalEnum on 132 of 1506 records; the enum is authoritative. */
  allowHalfDays: boolean
  isLegallyRequired: boolean
  legalNote: string
  shortestLeaveIntervalEnum: string
  isDefault: boolean
}

export interface ILeaveLawEntry {
  id: number
  displayName: string
  /** ISO 3166-1 alpha-2, uppercase. */
  countryCode: string
  /** Bare lowercase ISO 3166-2 suffix ('wy'), not the full code we store ('US-WY'). */
  subdivisionCode: string | null
  suggestedLeaveTypes: ILeaveLawSuggestion[]
}

export type LeaveLawsResponse = Record<string, ILeaveLawEntry>

/** The two entitlements that map onto leave types we create by default. */
export enum LeaveLawKeyEnum {
  paidTimeOff = 'pto',
  sick = 'sick',
}
